<template>
  <div>
    <v-row justify="start"
           class="ma-n4">
      <v-col cols="12"
             sm="6"
             md="6"
             class="pa-0 ma-0">
        <v-card class="ma-4 pa-0 novostiWrapper">
          <v-responsive :aspect-ratio="21 / 9">
            <v-img src="@/assets/novosti-embrace.png"
                   :aspect-ratio="21 / 9"
                   gradient="to right bottom, rgba(40, 40, 40, 0.92), rgba(60, 60, 60, 0.55)">
              <v-container fill-height
                           fluid
                           pa-2>
                <v-layout fill-height>
                  <v-flex xs12
                          align-end
                          flexbox>
                    <h1 class="text-h5 font-weight-thin mb-3 white--text">
                      Arox proizvodnja razvija novi proizvod za izvozno tržište
                    </h1>
                    <v-btn text
                           class="font-weight-medium mb-3 white--text"
                           color="white"
                           href="https://drive.google.com/file/d/1FCZNNuuHdx8A8I5iHvRWRCzxGUkApMEA/view?usp=drive_link"
                           target="_blank">Pregledajte
                      <v-icon right>
                        mdi-open-in-new
                      </v-icon>
                    </v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-img>
          </v-responsive>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'Novosti',
};
</script>

<style lang="scss" scoped>
.novostiWrapper {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
}
</style>
